<template>
  <div class="popup-base" v-if="open">
    <div class="popup-mask" @click="$emit('update:open',false)"/>
    <div class="popup-box" :class="{show:open}" v-bind="$attrs">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ open: boolean }>()
defineEmits(['update:open'])
</script>

<style scoped lang="sass">

.popup-base
  z-index: 888

  > .popup-mask
    position: fixed
    left: 0
    top: 0
    right: 0
    bottom: 0
    background-color: rgba(0, 0, 0, 0.43)

  > .popup-box
    opacity: 0
    transition: all .3s
    position: fixed
    left: 50%
    top: 50%
    background-color: transparent
    transform: translate(-50%, -50%)
    border-radius: 12px
    overflow: hidden

  > .show
    opacity: 1

</style>